import React          from 'react'
import classNames     from 'classnames'
import { InputGroup } from 'react-bootstrap'

import './button_input_addon.sass'

export default ButtonInputAddon = ({ id, className = '', disabled, onClick, children }) ->
  <InputGroup.Addon id={id}
                    className={classNames('button-input-addon', className, disabled: disabled)}
                    onClick={if disabled then (->) else onClick}>
    {children}
  </InputGroup.Addon>
